import React, { useState } from 'react';
import { CCol, CRow } from '@coreui/react';
import { defaultImgCDN, getFullDate12Hr, imageString } from '../../helper';
import StatusInTable from '../../components/StatusInTable';
import { STATUS_MAP } from '../../utils/mappings';
import { useTranslation } from 'react-i18next';
import {
  InputSeparator,
  SettingsModalBoldText,
  SettingsModalLightText
} from '../settings/SettingsModals';
import { ImageContainer, StyledImage } from '../settings/SettingsImages';
import { useSelector } from 'react-redux';
import { Flex } from '../../components/ui/Flex';
import { SettingsItem } from '../settings/SettingsItem';

const BookingStatus = ({ booking }) => {
  const { t } = useTranslation();
  const [errorImage, setErrorImage] = useState('');

  const filterObject = (array, id) => {
    if (array && id) {
      const resultArray = array.filter((obj) => obj.id === id);
      return resultArray[0];
    }
    return undefined;
  };
  return (
    <Flex direction="column" gap="13px">
      <InputSeparator rowGap="5px">
        <SettingsModalBoldText>{booking && booking.title}</SettingsModalBoldText>
        <SettingsModalLightText>
          {booking && booking.create_date && getFullDate12Hr(booking.create_date)}
        </SettingsModalLightText>
      </InputSeparator>

      <InputSeparator rowGap="7px">
        <SettingsModalBoldText>{t('Status')}</SettingsModalBoldText>
        <SettingsModalLightText>
          <StatusInTable
            status={
              filterObject(STATUS_MAP, booking && booking.status) &&
              filterObject(STATUS_MAP, booking && booking.status).value
            }
          />
        </SettingsModalLightText>
      </InputSeparator>
    </Flex>
  );
};

export default BookingStatus;
